import { directusApi } from "./api";
import moment from 'moment-timezone';

export async function asyncForEach(array: Array<any>, callback: any) {
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
};

export const formatNested = function (flatArray: any[], id: any, parentId: any) {
    let collection = [];
    flatArray.forEach(item => (collection[item[id]] = { ...item, children: [] }));
    let result = [];
    flatArray.forEach(item => {
        if (item[parentId]) {
            if (collection[item[parentId]]) {
                collection[item[parentId]].children.push(collection[item[id]]);
            }
        } else {
            result.push(collection[item[id]]);
        }
    });
    return result;
};

export const isToday = function (dateString: any) {
    const inputDate = new Date(dateString);
    const today = new Date();
    return (
        inputDate.getFullYear() === today.getFullYear() &&
        inputDate.getMonth() === today.getMonth() &&
        inputDate.getDate() === today.getDate()
    );
}

export const validateFileName = async function (filename: any) {
    console.log({ filename });
    let value = null;
    try {
        await directusApi('GET', `files?search=${filename}&limit=1&meta=filter_count`)
            .then(async (resFile: any) => {
                // console.log(parseInt(resFile.data.meta.filter_count));
                value = parseInt(resFile.data.meta.filter_count);
            })
            .catch(err => {
                console.log(err);
                value = 20;
            });
    } catch (error) {
        console.log({ error });
        value = 20;
    }
    return value;
};

export const round = async function (roundNumber: number) {
    // console.log(roundNumber);
    let result = 0;
    let m = Number((Math.abs(roundNumber) * 100).toPrecision(15));
    result = Math.round(m) / 100 * Math.sign(roundNumber);
    return result;
}

export function validateStatusOrders(status: any, order_status: any) {
    status == 'Sinenvío' ? status = order_status : status = status;
    // console.log({status});
    switch (status) {
        case "pending":
            status = "Pendiente";
            return { status: status, variant: 'primary' };
            break;
        case "delivered":
            status = "Entregado";
            return { status: status, variant: 'success' };
            break;
        case "returns":
            status = 'Devolución';
            return { status: status, variant: 'info' };
            break;
        case "mediations":
            status = 'Reclamo';
            return { status: status, variant: 'danger' };
            break;
        case "cancel_purchase":
            status = 'Cancelación de compra (comprador)';
            return { status: status, variant: 'danger' };
            break;
        case "cancel_sale":
            status = 'Cancelación de compra (vendedor)';
            return { status: status, variant: 'danger' };
            break;
        case "cancelled":
            status = "Cancelada";
            return { status: status, variant: 'danger' };
            break;
        case "ready_to_print":
            status = "Etiqueta lista para imprimir";
            return { status: status, variant: 'orange' };
            break;
        case "regenerating":
            status = "Etiqueta lista para imprimir";
            return { status: status, variant: 'orange' };
            break;
        case "ready_for_pickup":
            status = "Listo para recolección";
            return { status: status, variant: 'orange' };
            break;
        // case "confirmed":
        //     status = "Confirmada";
        //     return { status: status };
        //     // order.status = 'confirm';
        //     break;
        // case "payment_required":
        //     status = "Pago requerido";
        //     return { status: status, variant: 'primary' };
        //     break;
        // case "payment_in_process":
        //     status = "Pago en proceso";
        //     return { status: status, variant: 'primary' };
        //     break;
        // case "partially_paid":
        //     status = "Parcialmente pagado";
        //     return { status: status, variant: 'primary' };
        //     break;
        // case "paid":
        //     status = "Pagada";
        //     return { status: status, variant: 'primary' };
        //     break;
        // case "invalid":
        //     status = "Invalida";
        //     return { status: status, variant: 'primary' };
        //     break;
        // case "to_be_agreed":
        //     status = "A convenir";
        //     return { status: status, variant: 'primary' };
        //     break;
        // case "ready_to_ship":
        //     status = "Listo para enviar";
        //     return { status: status, variant: 'primary' };
        //     break;
        // case "not_delivered":
        //     status = "No entregada";
        //     return { status: status, variant: 'primary' };
        //     break;
        // case "closed":
        //     status = "Cerrada";
        //     return { status: status, variant: 'primary' };
        //     break;
        case "printed":
            status = "Etiqueta impresa";
            return { status: status, variant: 'orange' };
            break;
        // case "ready_to_print":
        //     status = 'Listo para imprimir';
        //     return { status: status, variant: 'primary' };
        //     break;
        //****************** PROCESANDO EN LA BODEGA */
        case "in_packing_list":
            status = 'Procesando en la bodega';
            return { status: status, variant: 'gray' };
            break;
        case "in_warehouse":
            status = 'Procesando en la bodega';
            return { status: status, variant: 'gray' };
            break;
        case "ready_to_pack":
            status = 'Procesando en la bodega';
            return { status: status, variant: 'gray' };
            break;
        //****************** PROCESANDO EN LA BODEGA */

        //****************** EN CAMINO */
        case "receiver_absent":
            status = 'En camino';
            return { status: status, variant: 'indigo' };
            break;
        case "shipped":
            status = "En camino";
            return { status: status, variant: 'indigo' };
            break;
        case "picked_up":
            status = "En camino";
            return { status: status, variant: 'indigo' };
            break;
        case "out_for_delivery":
            status = 'En camino';
            return { status: status, variant: 'indigo' };
            break;
        case "delayed":
            status = 'En camino';
            return { status: status, variant: 'indigo' };
            break;
        case "in_hub":
            status = 'En camino';
            return { status: status, variant: 'indigo' };
            break;
        case "authorized_by_carrier":
            status = 'En camino';
            return { status: status, variant: 'indigo' };
            break;
        //****************** EN CAMINO */
        // case "waiting_for_withdrawal":
        //     status = 'Esperando el retiro';
        //     return { status: status, variant: 'primary' };
        //     break;

        //pending to check ***********************************
        // case "claim":
        //     status = 'Reclamo';
        //     return { status: status, variant: 'danger' };
        //     break;
        // case "opened":
        //     status = 'Reclamo';
        //     return { status: status, variant: 'danger' };
        //     break;
        // case "claim_closed":
        //     status = 'Reclamo cerrado';
        //     return { status: status, variant: 'info' };
        //     break;
        // case "return":
        //     status = 'Devolución';
        //     return { status: status, variant: 'warning' };
        //     break;
        //pending to check ***********************************
        // case "pack_splitted":
        //     status = 'Paquete dividido';
        //     return { status: status, variant: 'primary' };
        //     break;
        case "fraudulent":
            status = 'Fraudulento';
            return { status: status, variant: 'danger' };
            break;
        case "unfulfillable":
            status = 'Cancelada por Mercado Libre';
            return { status: status, variant: 'danger' };
            break;
        //****************** EN DEVOLUCIÓN */
        case "returned_to_hub":
            status = 'En devolución';
            return { status: status, variant: 'blueReturn' };
            break;
        case "returning_to_sender":
            status = 'En devolución';
            return { status: status, variant: 'blueReturn' };
            break;
        case "returning_to_hub":
            status = "En devolución";
            return { status: status, variant: 'blueReturn' };
            break;
        //****************** EN DEVOLUCIÓN */

        //****************** DEVUELTO */
        case "returned_to_warehouse":
            status = 'Devuelto';
            return { status: status, variant: 'return' };
            break;
        case "returned":
            status = 'Devuelto';
            return { status: status, variant: 'return' };
            break;
        //****************** DEVUELTO */

        //****************** NO ENTREGADO */
        case "to_review":
            status = 'No entregado';
            return { status: status, variant: 'danger' };
            break;
        case "destroyed":
            status = 'No entregado';
            return { status: status, variant: 'danger' };
            break;
        case "lost":
            status = "No entregado";
            return { status: status, variant: 'danger' };
            break;
        case "stolen":
            status = "No entregado";
            return { status: status, variant: 'danger' };
            break;
        //****************** NO ENTREGADO */
        case "claimed_me":
            status = 'Cancelada por el comprador';
            return { status: status, variant: 'danger' };
            break;

        case "manufacturing":
            status = 'Esperando disponibilad de stock';
            return { status: status, variant: 'orange' };
            break;

        case "procesando_en_prodelec":
            status = 'Procesando en Prodelec';
            return { status: status, variant: 'orange' };
            break;
        // case "waiting_for_payment":
        //     status = 'Esperando el pago';
        //     return { status: status, variant: 'primary' };
        //     break;
        case "handling":
            status = 'En proceso';
            return { status: status, variant: 'primary' };
            break;
        case "creating_route":
            status = 'Generando ruta';
            return { status: status, variant: 'primary' };
            break;
        case "shipment_paid":
            status = 'Envío reprogramado';
            return { status: status, variant: 'orange' };
            break;
        // case "buffered":
        //     status = 'Envío próximo';
        //     return { status: status, variant: 'primary' };
        //     break;
        // case "null":
        //     status = "";
        //     return { status: status, variant: '' };
        //     break;
        // case "undefined":
        //     status = "";
        //     return { status: status, variant: '' };
        //     break;
        default:
            status = status;
            return { status: status, variant: 'primary' };
            break;
    }
}

export const formatMexicoTime = (dateStr) => {
    return moment.utc(dateStr).utcOffset(-360);
}

const LEGACY_STORE_BADGES: Record<string, { label: string; variant: string }> = {
    '5139': { label: 'Prodelec', variant: 'prodelec' },
    '4981': { label: 'Schneider Electric', variant: 'success' },
    '177250': { label: 'Klein Tools', variant: 'klein' },
    '304802': { label: 'Square D', variant: 'return' },
};

const MELI_BADGE = { label: 'Meli 1', variant: 'blueReturn' };
const OFFICIAL_ACCOUNT_BADGE = { label: 'Prodelec Oficial', variant: 'primary' };

function storeIdText(storeId: unknown) {
    return storeId == null ? '' : String(storeId).trim();
}

function isEmptyStore(storeId: unknown) {
    const id = storeIdText(storeId).toLowerCase();
    return !id || id === 'null' || id === 'undefined';
}

function storeVariant(storeId: unknown, storeName?: string | null) {
    const id = storeIdText(storeId);
    if (LEGACY_STORE_BADGES[id]) return LEGACY_STORE_BADGES[id].variant;
    if (id === 'prodelec' || id === '0') return 'blueReturn';
    if (!isEmptyStore(id)) return 'indigo';

    const name = String(storeName ?? '').trim().toLowerCase();
    if (name === 'klein tools') return 'klein';
    if (name === 'square d') return 'return';
    if (name === 'schneider electric') return 'success';
    if (name === 'prodelec') return 'prodelec';
    if (name === 'prodelec oficial') return 'primary';
    if (name === 'meli 1') return 'blueReturn';
    if (name) return 'indigo';
    return 'primary';
}

function legacyStoreBadge(storeId: unknown) {
    const id = storeIdText(storeId);
    if (isEmptyStore(id)) return OFFICIAL_ACCOUNT_BADGE;
    if (id === 'prodelec' || id === '0') return MELI_BADGE;
    return LEGACY_STORE_BADGES[id] || { label: id, variant: 'indigo' };
}

function savedStoreBadge(storeId: unknown, storeName?: string | null) {
    const id = storeIdText(storeId);
    const name = String(storeName ?? '').trim().toLowerCase();
    if (id === 'prodelec' || id === '0' || (isEmptyStore(id) && name === 'meli 1')) return MELI_BADGE;
    return { label: 'Prodelec Oficial', variant: 'primary' };
}

export function orderStoreBadge(item: { store?: unknown; store_name?: string | null } | null | undefined) {
    if (!item) return null;
    return savedStoreBadge(item.store, item.store_name);
}

function namedStoreBadge(storeId: unknown, storeName?: string | null) {
    const id = storeIdText(storeId);
    if (id.toLowerCase() === 'prodelec' || id === '0') return MELI_BADGE;
    if (LEGACY_STORE_BADGES[id]) return LEGACY_STORE_BADGES[id];
    const name = String(storeName ?? '').trim();
    if (name) return { label: name, variant: storeVariant(storeId, name) };
    return legacyStoreBadge(storeId);
}

export function publicationStoreBadge(item: { ml_store?: unknown; ml_store_name?: string | null } | null | undefined) {
    if (!item) return null;
    return namedStoreBadge(item.ml_store, item.ml_store_name);
}

export function questionStoreBadge(item: {
    ml_store?: unknown;
    ml_store_name?: string | null;
    store?: string | null;
} | null | undefined) {
    if (!item) return null;
    const id = storeIdText(item.ml_store);
    if (id.toLowerCase() === 'prodelec' || id === '0' || (isEmptyStore(id) && item.store === 'prodelec')) {
        return MELI_BADGE;
    }
    if (item.ml_store_name || !isEmptyStore(item.ml_store)) {
        return namedStoreBadge(item.ml_store, item.ml_store_name);
    }
    return OFFICIAL_ACCOUNT_BADGE;
}

